import { HTMLPreviewModal } from "../components/HTMLModal";
import { PublishSiteModal } from "../components/PublishModal";
import { PublishedSiteModal } from "../components/PublishedSiteModal";
import { BillingModal } from "../components/BillingModal"; // ajusta ruta
import { TemplateId } from "../../../templates/types/templates-ids.types";

type QuotaLike = {
    isLoading: boolean;
    canCreate?: boolean;
};

type PageBuilderTopBarModalsProps = {
    // html
    html: {
        showHTMLModal: boolean;
        generatedHTML: string;
        closeHTMLPreview: () => void;
        downloadHTML: () => void;
        copyHTML: () => void;
    };

    // publish
    publish: {
        isPublishModalOpen: boolean;
        togglePublishModal: () => void;
        closePublishModal?: () => void;

        isPublishedSiteModalOpen: boolean;
        togglePublishedSiteModal: () => void;
        openPublishedSiteModal?: () => void;
        closePublishedSiteModal?: () => void;
        isBillingModalOpen?: boolean;
        openBillingModal?: () => void;
        closeBillingModal?: () => void;

        // optional if you have it
        publishedSiteUrl?: string;
    };

    // publish inputs
    slugName: string;
    handleChangeSlug: (slug: string) => void;
    projectName: string;
    activeTemplateId: TemplateId;

    quota: QuotaLike;

    // actions
    publishSite: () => Promise<any>;
    onUpdateExistingSite?: () => void;
    onContinueToPayment?: () => void;
};

export function PageBuilderTopBarModals({
    html,
    publish,
    slugName,
    handleChangeSlug,
    projectName,
    activeTemplateId,
    quota,
    publishSite,
    onUpdateExistingSite,
    onContinueToPayment,
}: PageBuilderTopBarModalsProps) {
    const canCreate = quota.canCreate;

    return (
        <>
            {html.showHTMLModal && (
                <HTMLPreviewModal
                    html={html.generatedHTML}
                    onClose={html.closeHTMLPreview}
                    onDownload={html.downloadHTML}
                    onCopy={html.copyHTML}
                />
            )}

            <PublishSiteModal
                slug={slugName}
                onChangeSlug={handleChangeSlug}
                isOpen={publish.isPublishModalOpen}
                onClose={publish.togglePublishModal}
                onPublish={async () => {
                    // hardening: si quota cambió mientras estaba abierto
                    if (quota.isLoading) return;

                    if (canCreate === false) {
                        publish.closePublishModal?.();
                        publish.openPublishedSiteModal?.();
                        return;
                    }

                    await publishSite();
                }}
                businessUrl="www.app.flownect.com"
            />

            <PublishedSiteModal
                isOpen={publish.isPublishedSiteModalOpen}
                onClose={publish.togglePublishedSiteModal}
                businessUrl="www.app.flownect.com"
                slug={slugName}
                onUpdateSite={onUpdateExistingSite}
                onCreateNewSite={() => {
                    // "Create new site" -> open billing modal (if present)
                    publish.closePublishedSiteModal?.();
                    publish.openBillingModal?.();
                }}
            />

            <BillingModal
                isOpen={Boolean(publish.isBillingModalOpen)}
                onClose={publish.closeBillingModal ?? (() => { })}
                onContinue={onContinueToPayment}
            />
        </>
    );
}
